import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgRedAlarmExclamation = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={44}
    height={44}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M22 40.332c8.944 0 16.5-7.555 16.5-16.5 0-8.944-7.556-16.5-16.5-16.5-8.945 0-16.5 7.556-16.5 16.5 0 8.945 7.555 16.5 16.5 16.5ZM22 11c6.955 0 12.833 5.878 12.833 12.833 0 6.956-5.878 12.834-12.834 12.834-6.955 0-12.833-5.878-12.833-12.834C9.166 16.877 15.044 11 21.999 11Zm9.687-4.204L34.275 4.2l5.519 5.5-2.59 2.598-5.517-5.502ZM9.683 4.205l2.6 2.588-5.482 5.5-2.598-2.59 5.48-5.498Z"
      fill="red"
    />
    <path
      d="M20.166 16.5h3.667v9.167h-3.667V16.5Zm0 11h3.667v3.667h-3.667V27.5Z"
      fill="red"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRedAlarmExclamation);
export default ForwardRef;
